module.exports = __webpack_public_path__ + "static/media/testing_05@2x.e63e99f7.png";